<div class="text-center success-wrapper">
  <img src="assets/icons/like-success.svg" alt="" role="presentation"/>

  <h2 translate>components.signInModalComponent.gracias</h2>

  <ng-container *ngIf="!isSocialSignup; else socialSuccess">
    <h3 translate>components.signInModalComponent.cuentaCreada</h3>
    <p translate>
      components.signInModalComponent.enviadoEmail
      <br>
      components.signInModalComponent.spamEmail
    </p>
  </ng-container>
  <ng-template #socialSuccess>
    <h3 translate>components.signInModalComponent.cuentaCreadaSocial</h3>
  </ng-template>
</div>


